import { ErrorMessages, Player, ProfileSection } from 'types/global'
import { ActionType } from 'typesafe-actions'
import {
  UPDATE_OWN_PROFILE_REQUESTED,
  UPDATE_OWN_PROFILE_COMPLETED,
  UPDATE_OWN_PROFILE_FAILED,
  PLAYER_PROFILE_REQUESTED,
  PLAYER_PROFILE_COMPLETED,
  PLAYER_PROFILE_FAILED,
  OWN_PROFILE_REQUESTED,
  OWN_PROFILE_COMPLETED,
  OWN_PROFILE_FAILED,
  MATCH_RESULTS_REQUESTED,
  MATCH_RESULTS_COMPLETED,
  MATCH_RESULTS_FAILED,
  LOAD_MORE_MATCH_RESULTS_REQUESTED,
  LOAD_MORE_MATCH_RESULTS_COMPLETED,
  LOAD_MORE_MATCH_RESULTS_FAILED,
  PLAYER_STATS_REQUESTED,
  PLAYER_STATS_COMPLETED,
  PLAYER_STATS_FAILED,
  SET_FIRST_TOURNAMENT_DATE,
  SET_TOURNAMENTS_DATE_RANGE,
  SET_ACTIVE_SECTION,
  UPDATE_PROFILE_AVATAR_REQUESTED,
  UPDATE_PROFILE_AVATAR_COMPLETED,
  UPDATE_PROFILE_AVATAR_FAILED,
} from 'actions/profile-actions'
import * as actions from 'actions/profile-actions'
import moment from 'moment'
import { MessageTypes } from 'constants/message-screens'

type ProfileAction = ActionType<typeof actions>

export type State = Readonly<{
  ownProfile: null | Player
  ownProfileLoading: boolean
  ownProfileError: Error | null
  ownProfileErrorType: ErrorMessages
  updatingOwnProfile: boolean
  errorUpdatingOwnProfile: Error | null
  loadedProfile?: Player
  profileLoading: boolean
  profileError: Error | null
  profileErrorType: ErrorMessages
  loadedAvatarUrl?: string | null
  avatarUrlLoading: boolean
  avatarUrlError: Error | null
  totalTournamentsPlayed: number
  firstTournamentDate: string
  tournamentsDateRange: {
    start: string
    end: string
  }
  matchResultListings: any[]
  matchResultsLoading: boolean
  playerStats: any
  playerStatsLoading: boolean
  profileAvatarLoading: boolean
  activeSection: ProfileSection
}>

const initialState: State = {
  loadedProfile: undefined,
  profileLoading: true,
  profileError: null,
  profileErrorType: MessageTypes.DEFAULT,
  loadedAvatarUrl: null,
  avatarUrlLoading: true,
  avatarUrlError: null,
  ownProfile: null,
  ownProfileLoading: true,
  ownProfileError: null,
  ownProfileErrorType: MessageTypes.DEFAULT,
  updatingOwnProfile: false,
  errorUpdatingOwnProfile: null,
  totalTournamentsPlayed: 0,
  firstTournamentDate: '',
  tournamentsDateRange: {
    start: '',
    end: moment().toISOString(),
  },
  matchResultListings: [],
  matchResultsLoading: false,
  playerStats: {},
  playerStatsLoading: false,
  profileAvatarLoading: false,
  activeSection: ProfileSection.OVERVIEW,
}
// eslint-disable-next-line import/no-anonymous-default-export
export default function (state = initialState, action: ProfileAction): State {
  switch (action.type) {
    case UPDATE_OWN_PROFILE_REQUESTED:
      return { ...state, updatingOwnProfile: true, errorUpdatingOwnProfile: null }
    case UPDATE_OWN_PROFILE_FAILED:
      return { ...state, updatingOwnProfile: false, errorUpdatingOwnProfile: action.payload }
    case UPDATE_OWN_PROFILE_COMPLETED:
      return { ...state, updatingOwnProfile: false, ownProfile: action.payload }
    case PLAYER_PROFILE_REQUESTED:
      return { ...state, profileLoading: true, profileError: null }
    case PLAYER_PROFILE_COMPLETED:
      return { ...state, loadedProfile: action.payload, profileLoading: false, profileError: null }
    case PLAYER_PROFILE_FAILED:
      return {
        ...state,
        profileLoading: false,
        profileError: action.payload.error,
        profileErrorType: action.payload.type,
      }
    case OWN_PROFILE_REQUESTED:
      return { ...state, ownProfileLoading: true }
    case OWN_PROFILE_COMPLETED:
      return {
        ...state,
        ownProfile: action.payload,
        ownProfileLoading: false,
        ownProfileError: null,
      }
    case OWN_PROFILE_FAILED:
      return {
        ...state,
        ownProfileLoading: false,
        ownProfileError: action.payload.error,
        ownProfileErrorType: action.payload.type,
      }
    case MATCH_RESULTS_REQUESTED:
      return { ...state, matchResultsLoading: true }
    case MATCH_RESULTS_COMPLETED:
      return {
        ...state,
        matchResultsLoading: false,
        matchResultListings: [...action.payload.listings],
        totalTournamentsPlayed: action.payload.totalTournaments,
      }
    case MATCH_RESULTS_FAILED:
      return { ...state, matchResultsLoading: false }
    case LOAD_MORE_MATCH_RESULTS_REQUESTED:
      return { ...state, matchResultsLoading: true }
    case LOAD_MORE_MATCH_RESULTS_COMPLETED:
      return {
        ...state,
        matchResultsLoading: false,
        matchResultListings: [...state.matchResultListings, ...action.payload.listings],
        totalTournamentsPlayed: action.payload.totalTournaments,
      }
    case LOAD_MORE_MATCH_RESULTS_FAILED:
      return { ...state, matchResultsLoading: false }
    case SET_FIRST_TOURNAMENT_DATE:
      return { ...state, firstTournamentDate: action.payload }
    case SET_TOURNAMENTS_DATE_RANGE:
      return {
        ...state,
        tournamentsDateRange: { ...state.tournamentsDateRange, ...action.payload },
      }
    case PLAYER_STATS_REQUESTED:
      return { ...state, playerStatsLoading: true }
    case PLAYER_STATS_COMPLETED:
      return { ...state, playerStatsLoading: false, playerStats: action.payload }
    case PLAYER_STATS_FAILED:
      return { ...state, playerStatsLoading: false }
    case UPDATE_PROFILE_AVATAR_REQUESTED:
      return { ...state, profileAvatarLoading: true }
    case UPDATE_PROFILE_AVATAR_COMPLETED:
      return {
        ...state,
        profileAvatarLoading: false,
        loadedProfile: {
          ...(state.loadedProfile ?? ({} as Player)),
          avatar: action.payload
        },
      }
    case UPDATE_PROFILE_AVATAR_FAILED:
      return { ...state, profileAvatarLoading: false }
    case SET_ACTIVE_SECTION:
      return { ...state, activeSection: action.payload }
    default:
      return state
  }
}
